import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthenticationService } from 'src/app/_services';
import { UserInfoService } from 'src/app/_services/userInfo.service';
import { environment } from 'src/environments/environment';
import { MenuRouteID } from '../header/menu-item/nav-item';

@Component({
  selector: 'telio-grafana',
  templateUrl: './grafana.component.html',
  styleUrls: ['./grafana.component.scss']
})
export class GrafanaComponent implements OnInit {
  grafanaUrl = "";
  userDetails;
  userId;
  tenantID;
  currency;
  time_zone;

  constructor(private userInfoService: UserInfoService,
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService,) {
  }

  ngOnInit(): void {
    this.userDetails = this.userInfoService.userDetails;
    this.userId = this.userDetails.userId;
    this.tenantID = this.userDetails.tenantID;
    const baseUrl = environment.grafanaBaseUrl;
    this.currency = this.authenticationService.getLocalCurrency
    switch (+this.route.snapshot.paramMap.get('routeID')) {
      case MenuRouteID.REVENUE:
        this.getgrafanaurl(baseUrl + (this.userInfoService.isAdminGroup() ? `Q2LuwnnVz/revenue` : `Q2LuwnnVz12/revenue`));
        break;
      case MenuRouteID.FOOTFALL:
        this.getgrafanaurl(baseUrl + (this.userInfoService.isAdminGroup() ? `IV-Aq5H4k1/footfall` : `IV-Aq5H4k11/footfall`));
        break;
      case MenuRouteID.CHARGEBOX:
        this.getgrafanaurl(baseUrl + (this.userInfoService.isAdminGroup() ? `ZdZb3cH4z/chargebox` : `ZdZb3cH4z1/chargebox`));
        break;
      case MenuRouteID.DEEPDIVE:
        this.getgrafanaurl(baseUrl + (this.userInfoService.isAdminGroup() ? `5FdSGelVk/deep-dive` : `5FdSGelVY/deep-dive`));
        break;
    }
  }

  getOffset(timeZone) {
    const timeZoneName = Intl.DateTimeFormat("default", {
      timeZoneName: "short",
      timeZone,
    }).formatToParts()
      .find((i) => i.type === "timeZoneName").value;
    const offset = timeZoneName.slice(3);
    if (!offset) return 0;
    return offset;
  };

  getgrafanaurl(url) {
    let dataSharing = !!this.userDetails.dataSharing ? (this.userDetails.dataSharing == true ? 1 : 0) : 0 ;
    this.time_zone = this.authenticationService.getTimeZoneOffsetString(this.userInfoService.userDetails.prefCountry);
    this.grafanaUrl = this.userInfoService.isAdminGroup() ? (url + `?orgId=1&var-tenant_id=${this.tenantID}&var-currency=${this.currency}&var-time_zone=${this.time_zone}&var-user_id=${this.userId}&var-parent_id=${this.userDetails.parentId}&var-data_sharing=${dataSharing}&var-group=${this.userDetails.groups[0]}`) :
     url + `?orgId=1&var-user_id=${this.userId}&var-tenant_id=${this.tenantID}&var-currency=${this.currency}&var-time_zone=${this.time_zone}&var-parent_id=${this.userDetails.parentId}&var-data_sharing=${dataSharing}&var-group=${this.userDetails.groups[0]}`;
  }
}
